var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpBlackarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73528 0.257364C9.73528 0.119293 9.62335 0.00736431 9.48528 0.00736391L7.23528 0.00736377C7.09721 0.00736402 6.98528 0.119293 6.98528 0.257364C6.98528 0.395436 7.09721 0.507364 7.23528 0.507364L9.23528 0.507364L9.23528 2.50736C9.23528 2.64544 9.34721 2.75736 9.48528 2.75736C9.62335 2.75736 9.73528 2.64544 9.73528 2.50736L9.73528 0.257364ZM1.17678 8.91942L9.66206 0.434141L9.3085 0.0805873L0.823223 8.56587L1.17678 8.91942Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpBlackarrow);
export default __webpack_public_path__ + "static/media/up-blackarrow.293dab904583630c54745f2754f021e8.svg";
export { ForwardRef as ReactComponent };